import { jsPDF } from 'jspdf';
import { kksOk, mv, KKS_LIMIT } from './inspect';
import { clean, safeName } from './exporters';
import { APP_INFO } from './license';

const CLR = { red: [220, 38, 38], yellow: [202, 138, 4], green: [22, 163, 74] };

// one-page KKS measuring protocol / plan for the network operator
export function kksPlanPdf(t, project, list, months) {
  const doc = new jsPDF({ unit: 'mm', format: 'a4', orientation: 'landscape' });
  const M = 12, W = 273, dt = (v) => (v ? new Date(v).toLocaleDateString(t.locale) : '-');
  doc.setFillColor(15, 23, 42); doc.rect(0, 0, 297, 22, 'F');
  doc.setTextColor(255); doc.setFont('helvetica', 'bold'); doc.setFontSize(15);
  doc.text(clean(`${t.kpPdfTitle}${project.title ? ` - ${project.title}` : ''}`), M, 10);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  doc.text(clean(`${APP_INFO.name} · ${t.kpInterval}: ${months} · ${t.kkLimit} Eoff <= ${KKS_LIMIT} mV (Cu/CuSO4) · ${new Date().toLocaleString(t.locale)}`), M, 17);
  const cols = [[t.colNo, 10], [t.catName, 50], ['Eoff (mV)', 22], ['Eon (mV)', 22], [t.kkResult, 30], [t.kpLast, 28], [t.kpDue, 28], ['Status', 40], ['Lat / Lon', 43]];
  let y = 32;
  const row = (cells, bold, rgb) => {
    doc.setFont('helvetica', bold ? 'bold' : 'normal'); doc.setFontSize(8.6); doc.setTextColor(20);
    if (rgb) { doc.setFillColor(...rgb); doc.circle(M + 2, y - 1.3, 1.8, 'F'); }
    let x = M + 6;
    cells.forEach((c, i) => { if (rgb && i === 7) doc.setTextColor(...rgb); doc.text(clean(String(c)).slice(0, 44), x, y, { maxWidth: cols[i][1] - 2 }); doc.setTextColor(20); x += cols[i][1]; });
    y += 6.4; doc.setDrawColor(226, 232, 240); doc.line(M, y - 4.2, M + W, y - 4.2);
  };
  row(cols.map((c) => c[0]), true);
  list.forEach(({ f, r }, i) => {
    if (y > 185) return;
    const k = f.kks || {}, ok = kksOk(k);
    const st = !r.last ? t.kpNever.replace(/^[^\p{L}]+/u, '') : r.left < 0 ? t.scOver.replace('{n}', -r.left) : t.scLeft.replace('{n}', r.left);
    row([i + 1, f.name || t.fit_kks, mv(k.eoff) ?? '-', mv(k.eon) ?? '-', ok == null ? '-' : ok ? t.kkProt : t.kkUnprot, dt(r.last), dt(r.due), st, `${f.lat.toFixed(6)}, ${f.lon.toFixed(6)}`], false, CLR[r.st]);
  });
  y += 3;
  const n = (s) => list.filter((x) => x.r.st === s).length;
  doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
  doc.text(clean(`${n('red')} ${t.kpRed} · ${n('yellow')} ${t.kpYellow} · ${n('green')} ${t.kpGreen}`), M, y);
  y += 16;
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9); doc.setDrawColor(100, 116, 139);
  doc.line(M, y, M + 80, y); doc.line(M + 150, y, M + 230, y);
  doc.text(clean(t.kpSigTech), M, y + 4); doc.text(clean(t.kpSigOp), M + 150, y + 4);
  doc.setFontSize(7); doc.setTextColor(120); doc.text(clean(`${APP_INFO.name} · ${list.length} KKS`), M, 202);
  doc.save(`${safeName(`KKS-Messprotokoll ${project.title || ''}`)}.pdf`);
}
